export default {
  'menu.account': '个人中心',
  'menu.account.center': '个人信息',
  'menu.dashboard': '仪表盘',
  'menu.devices': '设备管理',
  'menu.devices.list': '设备列表',
  'menu.addressBook': '地址簿',
  'menu.addressBook.personal': '个人地址簿',
  'menu.addressBook.shared': '共享地址簿',
  'menu.deviceGroups': '设备组',
  'menu.deviceGroups.list': '设备组列表',
  'menu.users': '用户管理',
  'menu.audits': '审计日志',
  'menu.audits.conn': '连接审计',
  'menu.audits.file': '文件审计',
  'menu.audits.alarm': '告警审计',
  'menu.audits.console': '控制台审计',
  'menu.login': '登录',
  'menu.roles': '角色管理',
  'menu.strategies': '策略管理',
  'menu.groups': '组管理',
  'menu.groups.user': '用户组',
  'menu.groups.device': '设备组',
  'menu.settings': '设置',
  'menu.settings.smtp': 'SMTP 配置',
  'menu.settings.oidcProviders': 'OIDC 提供商',
  'menu.customClients': '自定义客户端',
  'menu.addressBooks': '地址簿',
  'menu.list.audit-list': '审计列表',
  'menu.list.audit-list.File': '文件传输',
  'menu.list.audit-list.Connection': '连接审计',
};
